module.exports = __webpack_public_path__ + "assets/img/img54.cfbd0b14.png";